// extracted by mini-css-extract-plugin
export var description = "CruiseDrawerSaveThisQuoteDisclaimer-module--description--d48a1";
export var disclaimerContainer = "CruiseDrawerSaveThisQuoteDisclaimer-module--disclaimer-container--221b1";
export var disclaimerTextContainer = "CruiseDrawerSaveThisQuoteDisclaimer-module--disclaimer-text-container--6fc60";
export var title = "CruiseDrawerSaveThisQuoteDisclaimer-module--title--ea36b";